import { Justification } from '@schooly/api';
import { AttendanceGridStudent, AttendanceSidebarData } from '../AttendanceTable/common/types';

export type JustificationSidebarSelection = {
  data: AttendanceSidebarData;
  student: AttendanceGridStudent;
};

export const getJustificationSidebarSelection = (
  justification: Justification,
): JustificationSidebarSelection | null => {
  const { attendance_entries, relation } = justification;
  const [firstEntry] = attendance_entries;

  if (!firstEntry) return null;

  return {
    student: { ...relation, last_name: relation.last_name ?? '' },
    data: {
      register_id: firstEntry.register.id,
      date: firstEntry.register.date,
      relation_id: relation.relation_id,
    },
  };
};
